import {
  CircularProgress,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { validMessage } from '../../../constants/ValidsFormConst';
import { useNotification } from '../../../helpers/Notification';
import { LoadingWidget } from '../../../widgets';
import { Links } from '../../control_estudios/materias/components/ListadoMaterias';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { LOADING_ALL_CIUDADES } from '../../ubigeo/ciudades/CiudadesReducer';
import SelectFieldCiudadesComponent from '../../ubigeo/ciudades/components/SelectFieldCiudades';
import { LOADING_ALL_ESTADOS } from '../../ubigeo/estados/EstadosReducer';
import SelectFieldEstadosComponent from '../../ubigeo/estados/components/SelectFieldEstados';
import SelectFieldPaisesComponent from '../../ubigeo/paises/components/SelectFieldPaises';
import { saveDireccionesAction } from '../DireccionesAction';

const FormDirecciones = ({ setOpenModalForm = () => {}, params }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const direccionesStore = Redux.useSelector((state) => state.direcciones);
  const estadosStore = Redux.useSelector((state) => state.estados);
  const ciudadesStore = Redux.useSelector((state) => state.ciudades);

  const activo = direccionesStore.activo;

  const initData = {
    pais: '',
    estado: '',
    direccion: '',
    latitud: '',
    longitud: '',
    isPrincipal: false,
    idCiudad: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    direccion: false,
    estado: false,
    idCiudad: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    dispatch({ type: LOADING_ALL_ESTADOS, payload: true });
    dispatch({ type: LOADING_ALL_CIUDADES, payload: true });
    setTimeout(() => {
      setData({
        ...values,
        pais: activo?.ciudad?.estado?.pais?.id ?? 1,
      });
      setTimeout(() => {
        setData({
          ...values,
          pais: activo?.ciudad?.estado?.pais?.id ?? 1,
          estado: activo?.ciudad?.estado?.id,
        });
        dispatch({ type: LOADING_ALL_ESTADOS, payload: false });
      }, 1000);
      setTimeout(() => {
        setData({
          ...values,
          pais: activo?.ciudad?.estado?.pais?.id ?? 1,
          estado: activo?.ciudad?.estado?.id,
          idCiudad: activo?.ciudad?.id,
        });
        dispatch({ type: LOADING_ALL_CIUDADES, payload: false });
      }, 1000);
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  React.useEffect(() => {
    setTimeout(() => {
      const values = {
        ...data,
        pais: 1,
        estado: null,
        idCiudad: null,
      };

      setData(values);
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const values = {
      ...data,
      estado: null,
      idCiudad: null,
    };

    setData(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.pais]);

  React.useEffect(() => {
    const values = {
      ...data,
      idCiudad: null,
    };

    setData(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.estado]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const { idCiudad, direccion, latitud, longitud, isPrincipal } = data;
      const res = await saveDireccionesAction(
        { dispatch, notify },
        activo?.id,
        {
          idCiudad,
          direccion,
          latitud,
          longitud,
          isPrincipal,
          ...params,
        },
        {
          ...direccionesStore.params,
          ...params,
        },
      );
      setLoadingSave(false);
      if (res) setOpenModalForm(false);
    }
  };

  const validateLatitude = (latitude) => {
    const latitudeRegex = /^([-+]?)([\d]{1,2})(((\.)(\d+))?)$/;
    return latitudeRegex.test(latitude);
  };

  const validateLongitude = (longitude) => {
    const longitudeRegex = /^([-+]?)([\d]{1,3})(((\.)(\d+))?)$/;
    return longitudeRegex.test(longitude);
  };

  const handleDataChange = (e) => {
    const { name, value } = e.target;

    setData({ ...data, [name]: value });

    if (!value || value === '') {
      return setDataRequired({ ...dataError, [name]: false });
    }

    if (name === CONST.latitud.name) {
      const isValidLatitude = validateLatitude(value);
      setDataRequired({ ...dataError, latitud: !isValidLatitude });
    }

    if (name === CONST.longitud.name) {
      const isValidLongitude = validateLongitude(value);
      setDataRequired({ ...dataError, longitud: !isValidLongitude });
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          Link de busqueda e información:{' '}
          <Links
            target="_blank"
            href="https://www.countrycoordinate.com/search/?keywords=Venezuela"
          >
            <strong>Coordenadas de países</strong>
          </Links>
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectFieldPaisesComponent
            value={data.pais}
            onChange={(id) => _handleSetDataField(CONST.pais.name, id)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {data.pais && (
            <Stack direction="row" spacing={1}>
              {estadosStore.loadingAll && (
                <CircularProgress color="inherit" size={20} />
              )}
              <SelectFieldEstadosComponent
                idPais={data.pais}
                value={Number(data.estado)}
                onChange={(id) => _handleSetDataField(CONST.estado.name, id)}
                required
                hasError={dataError.estado}
              />
            </Stack>
          )}
        </Grid>
        <Grid item xs={12} md={12}>
          {data.estado && (
            <Stack direction="row" spacing={1}>
              {ciudadesStore.loadingAll && (
                <CircularProgress color="inherit" size={20} />
              )}
              <SelectFieldCiudadesComponent
                idEstado={data.estado}
                value={Number(data.idCiudad)}
                onChange={(idCiudad) =>
                  _handleSetDataField(CONST.ciudad.idName, idCiudad)
                }
                required
                hasError={dataError.ciudad}
              />
            </Stack>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.latitud.name}
            name={CONST.latitud.name}
            label={CONST.latitud.label}
            value={data.latitud}
            onChange={handleDataChange}
            inputProps={{
              maxLength: 7,
            }}
            helperText={dataError.latitud ? validMessage.required : null}
            error={dataError.latitud}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.longitud.name}
            name={CONST.longitud.name}
            label={CONST.longitud.label}
            value={data.longitud}
            onChange={handleDataChange}
            inputProps={{
              maxLength: 7,
            }}
            helperText={dataError.longitud ? validMessage.required : null}
            error={dataError.longitud}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.direccion.name}
            required
            label={CONST.direccion.label}
            value={data.direccion}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.direccion.name, e.target.value)
            }
            helperText={dataError.direccion ? validMessage.required : null}
            error={dataError.direccion}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Switch
                checked={data.isPrincipal}
                onChange={(event) => {
                  _handleSetDataField(
                    CONST.isPrincipal.name,
                    event.target.checked,
                  );
                }}
              />
            }
            label="Dirección principal"
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            loading={loadingSave}
            click={_handleSubmit}
            save
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormDirecciones;
